import React from "react";
import * as Layout from 'react-bootstrap';
import Logo from '../../../assets/logo.png';

const Header = () => {
    /*** Return output ***/
    return (
        <Layout.Navbar className="mb-3">
            <Layout.NavbarBrand>
                <Layout.NavLink href="/">
                    <img src={Logo} alt="Logo" />
                </Layout.NavLink>
            </Layout.NavbarBrand>
        </Layout.Navbar>
    );
}

export default Header;